import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { LocalStorageService } from 'src/services/local-storage.service';

@Component({
    selector: 'app-body-heatmap',
    templateUrl: './body-heatmap.component.html',
    styleUrls: ['./body-heatmap.component.scss'],
    standalone: false
})
export class BodyHeatmapComponent implements OnInit, AfterViewInit {
  @Input() gender: 'male' | 'female' = 'male';
  @Input() side: 'front' | 'back' = 'front';
  @Input() exerciseData: { muscle: string; value: number }[] = [];

  constructor(private localStorageService: LocalStorageService) {}

  ngOnInit() {
    this.loadGender();
  }

  ngAfterViewInit() {
    this.updateMuscleColors();
  }

  loadGender() {
    const savedGender = this.localStorageService.getGender();
    if (savedGender) {
      this.gender = savedGender;
    }
  }

  updateMuscleColors() {
    const maxExercise = Math.max(
      ...this.exerciseData.map((data) => data.value),
      0
    );
    this.exerciseData.forEach((data) => {
      const muscleElements = this.querySelectorAllById(data.muscle);
      muscleElements.forEach((element) => {
        (element as SVGElement).style.fill = this.getHeatMapColor(
          data.value,
          maxExercise
        );
      });
    });
  }

  querySelectorAllById(id: string): NodeListOf<Element> {
    return document.querySelectorAll(`[id='${id}']`);
  }

  getHeatMapColor(value: number, max: number): string {
    const ratio = value / max;
    const red = Math.min(255, Math.floor(255 * ratio));
    const blue = 255 - red;
    return `rgb(${red}, 0, ${blue})`;
  }
}
